window.iemall_cfg = {
  // 页头 topbar
  topbar() {
    return {
      fixed: false,
      is_top: false,
      hidden_nav: true,
      active: -1,
      logo: {
        alt: "kimi-mall",
        url: "/",
        img: "/img/kimi--logo.png",
        img_r: "/img/kimi--logo.png"
      },
      nav: [
        {
          type: "url",
          url: "/",
          text: "首页"
        },
        {
          type: "url",
          url: "/channel_join",
          text: "渠道加盟"
        },
        {
          type: "url",
          url: "/business",
          text: "品牌招商"
        },
        {
          type: "url",
          url: "/school_1",
          text: "跨境商学院"
        },
        // {
        //   type: "url",
        //   url: "/about",
        //   text: "关于我们"
        // },
        // {
        //   type: "url",
        //   url: "http://ezymall.com",
        //   text: "商城入口",
        //   target: 'blank'
        // },
        // {
        //   type: "button",
        //   url: "/en",
        //   text: "English"
        // },
        {
          type: "button_default",
          url: "https://mall.kimi.global/merchant",
          text: "登录"
        }
      ],
      setup(k, active) {
        if (k) {
          this.fixed = !!k;
          this.is_top = !!k;
        } else {
          this.listener();
        }
        this.active = active;
      },
      listener() {
        var self = this;
        window.addEventListener("scroll", function() {
          self.is_top = document.body.scrollTop > 100 || window.scrollY > 100;
        });
      },
      getLogo() {
        return this.isTop() ? this.logo.img_r : this.logo.img;
      },
      switchNav() {
        this.hidden_nav = !this.hidden_nav;
      },
      isTop() {
        return this.is_top || !this.hidden_nav;
      },
      getLangUrl() {
        return location.pathname.replace(/^\//, "/en/");
      }
    };
  },
  // 页脚 footer
  footer() {
    return {
      logo_img: "/img/kimi--logo.png",
      copyright: "Copyright © 2019-2025",
      links: [
        {
          name: "渠道加盟",
          sub: [
            {
              url: "/channel_join",
              target: "blank",
              name: "渠道优势"
            },
            {
              url: "/channel_join",
              target: "blank",
              name: "代理政策"
            },
            {
              url: "/channel_join",
              target: "blank",
              name: "加盟流程"
            },
            {
              url: "/channel_join#contact_us",
              target: "blank",
              name: "联系我们"
            }
          ]
        },
        {
          name: "品牌招商",
          sub: [
            {
              url: "/business",
              target: "blank",
              name: "入驻流程"
            },
            {
              url: "/business",
              target: "blank",
              name: "入驻须知"
            },
            {
              url: "/business",
              target: "blank",
              name: "商铺要求"
            },
            {
              url: "/business",
              target: "blank",
              name: "申请资质"
            },
            {
              url: "/business",
              target: "blank",
              name: "费率标准"
            }
          ]
        },
        {
          name: "跨境商学院",
          sub: [
            {
              url: "/school_1",
              target: "blank",
              name: "行业须知"
            },
            {
              url: "/school_2",
              target: "blank",
              name: "仓储物流"
            },
            {
              url: "/school_3",
              target: "blank",
              name: "赔付标准"
            },
            {
              url: "/school_4",
              target: "blank",
              name: "售后服务"
            }
          ]
        },
        // {
        //   name: "关于我们",
        //   sub: [
        //     {
        //       url: "/about",
        //       target: "blank",
        //       name: "关于我们"
        //     }
        //   ]
        // }
      ]
    };
  },

  // 幻灯页 slide
  slide() {
    return {
      height: "1008px",
      current: 0,
      hasNext: false,
      hasIndicators: false,
      auto: false,
      timer: 5000,
      icon_left_url: "/img/slide/slide_left.png",
      icon_right_url: "/img/slide/slide_right.png",
      data: [{ class: "bg-blue-400", img: "/img/slide/slide_0.png" }],
      heading: ["诚信合作", "互利共赢"],
      sub_heading: ["诚信是商业合作的底线", "资证是实力企业的名片"],
      hidden_title_img: false,
      title_img: "/img/slide/title.png",
      title_height: "268px",
      setup() {
        this.height = window.screen.width < 640 ? "640px" : "1008px";
        if (this.auto) {
          this.autoPlay();
        }
      },
      updateCurrent(i) {
        if (this.current == i) return false;
        if (i < 0) i = this.data.length - 1;
        if (i > this.data.length - 1) i = 0;
        this.current = i;
        if (this.auto) {
          this.autoPlay();
        }
      },
      autoPlay() {
        this.autoplayTimer = setTimeout(() => {
          this.updateCurrent(this.current + 1);
        }, this.timer);
      },
      stopAutoPlay() {
        clearTimeout(this.autoplayTimer);
        this.autoplayTimer = null;
      }
    };
  },

  // 入职流程 join
  join() {
    return {
      title: "加盟流程",
      divide_img: "/img/step/i_r.png",
      list: [
        {
          type: "one",
          icon: "/img/step/ico_users.png",
          title: "Step1",
          sub: "用户注册",
          btn: {
            url: "https://mall.kimi.global/merchant_settled",
            name: "免费注册"
          },
          desc: "点击“免费注册”进行Kimi Mall商务平台用户注册"
        },
        {
          type: "one",
          icon: "/img/step/ico_business.png",
          title: "Step2",
          sub: "申请入驻",
          btn: {
            url: "https://mall.kimi.global/merchant_settled",
            name: "申请入驻"
          },
          desc: "在线填写信息并完成电子文档资质文件上传，点击提交完成入驻。"
        },
        {
          type: "one",
          icon: "/img/step/ico_files.png",
          title: "Step3",
          sub: "资质审核",
          btn: {
            url: "https://mall.kimi.global/merchant",
            name: "进度查询"
          },
          desc: "收到您的资质后，我们将在2个工作日内完成审核并告知结果。"
        },
        {
          type: "two",
          icon: "/img/step/ico_users.png",
          title: "分销渠道赋能",
          icon1: "/img/step/ico_done.png",
          title1: "佣金提现"
        }
      ],
      getData() {
        let arr = [];
        for (let i = 0; i < this.list.length; i++) {
          arr.push(this.list[i]);
          if (i != this.list.length - 1) {
            arr.push({
              type: "divide"
            });
          }
        }
        return arr;
      }
    };
  },

  // 图文展示 exhibition
  exhibition() {
    return {
      list: [
        {
          direction: "l",
          bg_color: "#DFEBFB",
          img: "/img/icon_iphone.png",
          img_pos: "right 120px",
          title: "下载 Kimi Mall App",
          sub: "管理您的销售渠道",
          btns: [
            {
              url: "https://apps.apple.com/cn/app/kimi-mall/id6529546170",
              name: "iPhone 版下载",
              icon: "/img/ico_apple.png",
              size: { height: "20px", width: "20px" }
            },
            {
              url: "https://kimi.global/kimi-mall.apk",
              name: "Android 版下载",
              icon: "/img/ico_android.png",
              size: { height: "20px", width: "20px" }
            }
          ]
        },
        {
          direction: "r",
          bg_color: "",
          img: "/img/icon_makbook.png",
          img_pos: "left 60px",
          title: "立刻登录 Kimi Mall 后台",
          sub: "上架您销售的商品",
          btns: [
            {
              url: "https://mall.kimi.global/merchant",
              name: "桌面管理后台",
              icon: "/img/ico_pc.png",
              blank: true,
              size: { height: "20px", width: "20px" }
            },
            // {
            //   url: "https://mshop.nzmai.com.cn/",
            //   name: "移动管理后台",
            //   icon: "/img/ico_phone.png",
            //   blank: true,
            //   size: { height: "20px", width: "20px" }
            // }
          ]
        }
      ],
      getList() {
        if (screen.width < 640) {
          for (let i = 0; i < this.list.length; i++) {
            this.list[i].img = "";
          }
        }
        return this.list;
      }
    };
  },

  // 合作品牌 brand
  brand() {
    return {
      title: "合作品牌",
      powered_by_icon: "/img/pharmacy.jpg",
      show_more_size: 13,
      more_text: ["查看更多", "More+"],
      more: true,
      list: [
        {
          name: "Shiseido 资生堂",
          icon: "/img/brand/Shiseido-Logo.png",
          url: "javascript:;"
        },
        {
          name: "Bayer 拜耳",
          icon: "/img/brand/bayer.png",
          url: "javascript:;"
        },
        {
          name: "Karicare 可瑞康",
          icon: "/img/brand/Karicare_Toddler.webp",
          url: "javascript:;"
        },
        {
          name: "Geoskincare 纽西之谜",
          icon: "/img/brand/Geoskincare.png",
          url: "javascript:;"
        },
        {
          name: "Me Today",
          icon: "/img/brand/Me_Today.png",
          url: "javascript:;"
        },
        {
          name: "Swisse 斯维诗",
          icon: "/img/brand/Swisse-new-logo2-e1576004964752.png",
          url: "javascript:;"
        },
        {
          name: "Thompson's 汤普森",
          icon: "/img/brand/Thompson's.jpg",
          url: "javascript:;"
        },
        {
          name: "Blackmores 澳佳宝",
          icon: "/img/brand/Blackmores.jpg",
          url: "javascript:;"
        },
        {
          name: "Elevit 爱乐维",
          icon: "/img/brand/Elevit.webp",
          url: "javascript:;"
        },
        {
          name: "Oral-B 欧乐B",
          icon: "/img/brand/Oral-B.png",
          url: "javascript:;"
        },
        {
          name: "Ostelin 奥斯特林",
          icon: "/img/brand/Ostelin.jpg",
          url: "javascript:;"
        },
        {
          name: "Trilogy 趣乐活",
          icon: "/img/brand/Trilogy.jpg",
          url: "javascript:;"
        },
        {
          name: "Karen Murrell",
          icon: "/img/brand/Karen_Murrell.webp",
          url: "javascript:;"
        },
        {
          name: "Red Seal 红印",
          icon: "/img/brand/Red_Seal.png",
          url: "javascript:;"
        },
        {
          name: "Cemoy 安瓶",
          icon: "/img/brand/Cemoy.png",
          url: "javascript:;"
        },
        {
          name: "Ugg",
          icon: "/img/brand/Ugg.png",
          url: "javascript:;"
        },
        {
          name: "Antipodes 安蒂碧斯",
          icon: "/img/brand/logo-antipodes.png",
          url: "javascript:;"
        },
        {
          name: "Comvita 康维他",
          icon: "/img/brand/Comvita.jpg",
          url: "javascript:;"
        },
        {
          name: "A2",
          icon: "/img/brand/A2.png",
          url: "javascript:;"
        },
        {
          name: "Anchor 安佳",
          icon: "/img/brand/anchor-logo.jpg",
          url: "javascript:;"
        },
        {
          name: "Go Healthy 高之源",
          icon: "/img/brand/Go_Healthy.png",
          url: "javascript:;"
        },
        {
          name: "Merino 美丽诺",
          icon: "/img/brand/Merino.jpg",
          url: "javascript:;"
        },
        {
          name: "Life Space",
          icon: "/img/brand/Life_Space.png",
          url: "javascript:;"
        },
        {
          name: "Clinicians 科立纯",
          icon: "/img/brand/Clinicians-logo_Lge.jpg",
          url: "javascript:;"
        },
        {
          name: "Bioisland 生物岛",
          icon: "/img/brand/bio-island-logo-vector.png",
          url: "javascript:;"
        },
        {
          name: "NutraLife 纽乐",
          icon: "/img/brand/NutraLife.jpg",
          url: "javascript:;"
        },
        {
          name: "The Good Vitamin Co.",
          icon: "/img/brand/The_Good_Vitamin.webp",
          url: "javascript:;"
        },
        {
          name: "Lancome 兰蔻",
          icon: "/img/brand/Lancome-Logo.png",
          url: "javascript:;"
        },
        {
          name: "Clinique 倩碧",
          icon: "/img/brand/Clinique.png",
          url: "javascript:;"
        },
        {
          name: "MitoQ",
          icon: "/img/brand/MitoQ_logo_600.webp",
          url: "javascript:;"
        },
        {
          name: "Elizabeth Arden",
          icon: "/img/brand/Elizabeth_Arden.webp",
          url: "javascript:;"
        },
        {
          name: "Kiehl's",
          icon: "/img/brand/Kiehls.jpg",
          url: "javascript:;"
        }
      ],
      getSize() {
        return document.body.offsetWidth > 370
          ? "180px"
          : document.body.offsetWidth > 300
          ? "150px"
          : document.body.offsetWidth / 2 - 10 + "px";
      },
      showMore() {
        if (this.more) this.more = false;
      }
    };
  },

  // channel_img_bg
  channel_img_bg() {
    return {
      bg: "/img/bg_channnel_join.png",
      title: "让跨境生意更简单",
      sub: "一站式纽澳跨境电商系统，轻松成就您的跨境事业"
    };
  },

  // 渠道优势 advantage
  advantage() {
    return {
      title: "渠道优势",
      active: 0,
      data: [
        {
          title: "跨境优势",
          icon: "/img/advantage/ico_kjys.png",
          icon_a: "/img/advantage/ico_kjys_a.png",
          img: "/img/advantage/bg_kjys.png",
          desc: [
            "健康，美妆，品质生活，",
            "纽日韩三地商品优选，",
            "原产地差异化优势提供高市场竞争力。"
          ]
        },
        {
          title: "在线 进销存",
          icon: "/img/advantage/ico_zxjxc.png",
          icon_a: "/img/advantage/ico_zxjxc_a.png",
          img: "/img/advantage/bg_zxjxc.png",
          desc: [
            "代销商品，商城一键下单，",
            "自动出货，物流跟踪，",
            "全程分润自动计算，销售管理一目了然。"
          ]
        },
        {
          title: "无需压货 官方服务",
          icon: "/img/advantage/ico_kf.png",
          icon_a: "/img/advantage/ico_kf_a.png",
          img: "/img/advantage/bg_kf.png",
          desc: [
            "无需自己打包发货，",
            "所有海淘商品Kimi Mall官方统一从原产地发货，统一售后服务，",
            "轻量化运营管理全力聚焦营销。"
          ]
        },
        {
          title: "线上线下 渠道融合",
          icon: "/img/advantage/ico_qdrh.png",
          icon_a: "/img/advantage/ico_qdrh_a.png",
          img: "/img/advantage/bg_qdrh.png",
          desc: [
            "线上零售，线下批发，",
            "全销售模式平台一体化集成，",
            "新零售与传统渠道优势同时利用。"
          ]
        }
      ],
      getActive() {
        return this.data[this.active];
      },
      setActive(key) {
        this.active = key;
      },
      getIcon(key) {
        return this.active == key ? this.data[key].icon_a : this.data[key].icon;
      }
    };
  },

  // 经销商 agency
  agency() {
    return {
      data: [
        {
          direction: "right",
          height: "696px",
          bg_img: "/img/bg_agency1.png",
          title: "省级经销商",
          sub: "代理政策",
          content: [
            {
              title: "加盟要求",
              desc: [
                "有较高的市场操作能力，能运作一个省级区的市场。",
                "有渠道拓展和管理能力，有能力将渠道覆盖到条件较好的县市。",
                "对加盟系列产品有很好的理解。",
                "负责合同约定局域内的市场和渠道建设。",
                "具备法人资格。",
                "有完成本地区任务的能力。",
                "加盟展示厅面积不小于300㎡",
                "加盟费900万人民币。"
              ]
            },
            {
              title: "加盟政策",
              desc: [
                "无需压货，无需投入售后服务，每一单的销售都有固定收入，完成任务获得相应市场经费奖励。",
                "总代理有权在授权许可区域内发展下级代理及零售代理点，原有区域内代理划归授权上级总代管理。",
                "连续3年完成经销商协议中规定的销售额，可以全额返还加盟费用。"
              ]
            }
          ]
        },
        {
          direction: "left",
          height: "673px",
          bg_img: "/img/bg_agency2.png",
          title: "地市级经销商",
          sub: "代理政策",
          content: [
            {
              title: "加盟要求",
              desc: [
                "有较高的市场操作能力，能运作一个省级区的市场。",
                "有渠道拓展和管理能力，有能力将渠道覆盖到条件较好的县市。",
                "对加盟系列产品有很好的理解。",
                "负责合同约定局域内的市场和渠道建设。",
                "具备法人资格。",
                "有完成本地区任务的能力。",
                "加盟展示厅面积不小于200㎡",
                "加盟费450万人民币。"
              ]
            },
            {
              title: "加盟政策",
              desc: [
                "无需压货，无需投入售后服务，每一单的销售都有固定收入，完成任务获得相应市场经费奖励。",
                "总代理有权在授权许可区域内发展下级代理及零售代理点，原有区域内代理划归授权上级总代管理。",
                "连续4年完成经销商协议中规定的销售额，可以全额返还加盟费用。"
              ]
            }
          ]
        },
        {
          direction: "right",
          height: "718px",
          bg_img: "/img/bg_agency3.png",
          title: "县级经销商",
          sub: "代理政策",
          content: [
            {
              title: "加盟要求",
              desc: [
                "有较高的市场操作能力，能运作一个省级区的市场。",
                "有渠道拓展和管理能力，有能力将渠道覆盖到条件较好的县市。",
                "对加盟系列产品有很好的理解。",
                "负责合同约定局域内的市场和渠道建设。",
                "具备法人资格。",
                "有完成本地区任务的能力。",
                "加盟展示厅面积不小于100㎡",
                "加盟费270万人民币。"
              ]
            },
            {
              title: "加盟政策",
              desc: [
                "无需压货，无需投入售后服务，每一单的销售都有固定收入，完成任务获得相应市场经费奖励。",
                "总代理有权在授权许可区域内发展下级代理及零售代理点，原有区域内代理划归授权上级总代管理。",
                "连续4年完成经销商协议中规定的销售额，可以全额返还加盟费用。 "
              ]
            }
          ]
        }
      ],
      eg:
        "例：区县级经销商使用平台销售新西兰原装A2奶粉，一罐￥200元，原装纸箱包装一箱6罐，年销售16700箱，年销售利润200万并获得市场经费奖励40万，共计年毛利240万。"
    };
  },

  // Contact contact
  contact() {
    return {
      title: "联系我们",
      sub:
        "如果你有兴趣成为我们的伙伴，我们很乐意听到你的声音，请留下联系方式，让我们把核算你的方案交给你。",
      desc: [
        "联系电话: +64 9 6006545",
        // "联系邮箱: kath.shi@miepay.com"
      ]
    };
  },

  // Get in touch in_touch
  in_touch() {
    return {
      title: "",
      height: "381px",
      bg: "/img/bg_getintouch.png",
      from: {
        controls: [
          {
            type: "text",
            name: "name",
            placeholder: "姓名"
          },
          {
            type: "text",
            name: "email",
            placeholder: "邮箱"
          },
          {
            type: "text",
            name: "message",
            placeholder: "留言"
          },
          {
            type: "button",
            name: "发送"
          }
        ]
      }
    };
  },

  // 品牌招商  business_img_bg
  business_img_bg() {
    return {
      height: "768px",
      bg: "/img/bg_ptys.png",
      title: "平台优势",
      sub: "为供应商提供跨境电商一体化解决方案",
      list: [
        {
          title: "跨境电商<br>供应链平台",
          icon: "/img/global.png",
          desc: [
            "平台：海外商家入驻零费用。",
            "展示：独立国家馆页面，精确展示品牌与商品",
            "流程：自助或托管管理商品和订单"
          ]
        },
        {
          title: "跨境电商",
          icon: "/img/global.png",
          desc: ["模式：全面支持跨境保税，跨境直邮，快件通道。"]
        },
        {
          title: "跨境结算",
          icon: "/img/global.png",
          desc: ["功能：为供应商提供人民币、外币等多币种的货款结算功能、"]
        },
        {
          title: "资源优势",
          icon: "/img/global.png",
          desc: [
            "品牌入驻有商家数量限制和资源要求，确保品牌商有足够的展位曝光，流量导入和销售转化。"
          ]
        }
      ],
      setup() {
        this.height = window.screen.width < 640 ? "640px" : "768px";
      }
    };
  },

  // 品牌招商  business_cooperate
  business_cooperate() {
    return {
      height: "700px",
      bg: "/img/bg_yqhz.png",
      title: "诚邀合作",
      sub: "真诚寻求战略合作伙伴关系",
      table: [
        [
          { type: "th", text: "入驻商家", cls: "bg-teal-200", bg: "#D5EDF9" },
          {
            type: "td",
            text: "新西兰匹配供应商、新西兰品牌授权商",
            colspan: 2,
            cls: "text-left bg-teal-200",
            bg: "#D5EDF9"
          }
        ],
        [
          {
            type: "th",
            text: "企业资质要求",
            rowspan: 2,
            cls: "bg-teal-200",
            bg: "#D5EDF9"
          },
          {
            type: "td",
            text: "新西兰品牌供应商 · 公司",
            cls: "text-left bg-teal-100",
            bg: "#E4F5FD"
          },
          {
            type: "td",
            text: "",
            list: [
              "可供产品清单",
              "注册商标证明文件",
              "质检报告",
              "奶粉、蜂蜜等初级产业部规定RMP产品报告"
            ],
            cls: "text-left bg-teal-100",
            bg: "#E4F5FD"
          }
        ],
        [
          {
            type: "td",
            text: "入驻品牌授权商 · 公司和合作品牌介绍商家",
            cls: "text-left bg-teal-100",
            bg: "#E4F5FD"
          },
          {
            type: "td",
            text: "",
            list: [
              "可供产品清单",
              "品牌授权文件",
              "当地商检局、厂家或第三方质检报告"
            ],
            cls: "text-left bg-teal-100",
            bg: "#E4F5FD"
          }
        ]
      ]
    };
  },

  // 品牌招商  business_flow
  business_flow() {
    return {
      title: "Kimi Mall商家入驻流程",
      btn: {
        href: "https://mall.kimi.global/merchant",
        text: "申请入驻"
      },
      divide_img: "/img/step/i_r.png",
      list: [
        {
          type: "box",
          icon: "/img/ico_file.png",
          title: "提交入驻资料",
          sub: "约2小时",
          desc: [
            "选择店铺类型/品牌/类目",
            "填写品牌信息",
            "填写企业信息",
            "店铺命名"
          ]
        },
        {
          type: "box",
          icon: "/img/ico_time.png",
          title: "商家等待审核",
          sub: "约7个工作日",
          desc: ["品牌评估", "资质审核"]
        },
        {
          type: "box",
          icon: "/img/ico_tick.png",
          title: "完成开店准备",
          sub: "约1天",
          desc: ["激活商家账号并登录", "签署协议并锁定保证金", "店铺命名"]
        },
        {
          type: "box",
          icon: "/img/ico_store.png",
          title: "店铺正式上线",
          sub: "",
          desc: ["发布商品并装修店铺"]
        }
      ],
      getData() {
        let arr = [];
        for (let i = 0; i < this.list.length; i++) {
          arr.push(this.list[i]);
          if (i != this.list.length - 1) {
            arr.push({
              type: "divide"
            });
          }
        }
        return arr;
      }
    };
  },

  // 跨境商学院 school_main
  school_main() {
    return {
      data: [
        {
          direction: "r",
          img_url: "/img/school/chess.png",
          align: false,
          width: "360px",
          height: "240px",
          cls: "bg-gray-100",
          title: "",
          desc_size: "",
          desc: [
            "Kimi Mall产品2018年7月上线，截止到2020年5月已经有138家商家入驻商家代理店铺已经拥有741家。iePay业务已经越来越聚焦本地中小商户，而支付通道的地域属性上中国消费者也是一个庞大的消费市场。我们作为聚合支付和业务创新的公司，一直致力于为新西兰的中小商户和他们生产的产品创造更旷阔的销售平台。",
            "Kimi Mall现有商户和新西兰本地中小品牌商拥有非常新西兰的商品，他们需要将商品推广到中国，但基于企业规模、对中国市场的了解、运输、支付等等问题，有很多商户无法拓展中国市场，他们非常渴望有平台可以帮助他们拓展中国市场。iePay在支付通道和商户的基础之上设计了一个IE跨境严选的平台，为本地中小品牌商户和中国消费者打通地域壁垒，实现无线链接。"
          ]
        },
        {
          direction: "l",
          img_url: "/img/school/tu_1.png",
          align: true,
          width: "560px",
          height: "360px",
          cls: "",
          title: "朝阳行业 抢占先机",
          desc_size: "text-sm",
          desc: [
            "Kimi Mall现有商户和新西兰本地中小品牌商拥有非常新西兰的商品，他们需要将商品推广到中国，但基于企业规模、对中国市场的了解、运输、支付等等问题，有很多商户无法拓展中国市场，他们非常渴望有平台可以帮助他们拓展中国市场。iePay在支付通道和商户的基础之上设计了一个IE跨境严选的平台，为本地中小品牌商户和中国消费者打通地域壁垒，实现无线链接。"
          ]
        },
        {
          direction: "r",
          img_url: "/img/school/tu_2.png",
          align: true,
          width: "560px",
          height: "360px",
          cls: "bg-gray-100",
          title: "稳步增长 更快更强",
          desc_size: "text-sm",
          desc: [
            "Kimi Mall现有商户和新西兰本地中小品牌商拥有非常新西兰的商品，他们需要将商品推广到中国，但基于企业规模、对中国市场的了解、运输、支付等等问题，有很多商户无法拓展中国市场，他们非常渴望有平台可以帮助他们拓展中国市场。iePay在支付通道和商户的基础之上设计了一个IE跨境严选的平台，为本地中小品牌商户和中国消费者打通地域壁垒，实现无线链接。"
          ]
        },
        {
          direction: "l",
          img_url: "/img/school/tu_3.png",
          align: true,
          width: "560px",
          height: "360px",
          cls: "",
          title: "市场空间 持续扩大",
          desc_size: "text-sm",
          desc: [
            "Kimi Mall现有商户和新西兰本地中小品牌商拥有非常新西兰的商品，他们需要将商品推广到中国，但基于企业规模、对中国市场的了解、运输、支付等等问题，有很多商户无法拓展中国市场，他们非常渴望有平台可以帮助他们拓展中国市场。iePay在支付通道和商户的基础之上设计了一个IE跨境严选的平台，为本地中小品牌商户和中国消费者打通地域壁垒，实现无线链接。"
          ]
        },
        {
          direction: "r",
          img_url: "/img/school/tu_4.png",
          align: true,
          width: "560px",
          height: "360px",
          cls: "bg-gray-100",
          title: "通关布局是线下店布局的痛点 恰恰是我们的优势",
          desc_size: "text-sm",
          desc: [
            "Kimi Mall现有商户和新西兰本地中小品牌商拥有非常新西兰的商品，他们需要将商品推广到中国，但基于企业规模、对中国市场的了解、运输、支付等等问题，有很多商户无法拓展中国市场，他们非常渴望有平台可以帮助他们拓展中国市场。iePay在支付通道和商户的基础之上设计了一个IE跨境严选的平台，为本地中小品牌商户和中国消费者打通地域壁垒，实现无线链接。"
          ]
        },
        {
          direction: "l",
          img_url: "/img/school/tu_5.png",
          align: true,
          width: "560px",
          height: "360px",
          cls: "",
          title: "行业领导者，拥抱科技变革， 持续微客服提供更为优质的服务！",
          desc_size: "text-sm",
          desc: [
            "Kimi Mall现有商户和新西兰本地中小品牌商拥有非常新西兰的商品，他们需要将商品推广到中国，但基于企业规模、对中国市场的了解、运输、支付等等问题，有很多商户无法拓展中国市场，他们非常渴望有平台可以帮助他们拓展中国市场。iePay在支付通道和商户的基础之上设计了一个IE跨境严选的平台，为本地中小品牌商户和中国消费者打通地域壁垒，实现无线链接。"
          ]
        }
      ]
    };
  },

  // 跨境商学院 school_other
  school_other() {
    return {
      school_1: [
        {
          question: "如果公司没有产品我是否可以将产品拿到公司进行发货？",
          answer: [
            "目前平台仅支持销售产品部统一采购进货的产品，暂不支持网站负责人自有产品销售。如果确实产品价格很好，可以联系客服申报新品推荐。如果各方面合适，会有专门的人员与您联系确认。另外随着平台发展，日后会在各方面进行优化，敬请期待。"
          ]
        },
        {
          question: "为什么网站上显示的新西兰本地价格比到中国价格还贵呢？",
          answer: [
            "产品在新西兰本地销售是要交税的，也就是比出口到中国增加了一部分的GST",
            "用户下单的邮寄到国内，使用的是人民币或者纽币不含税价。",
            "人在新西兰需要快递到新西兰本地或者用户到公司自提，使用的就是纽币或人民币含税价。",
            "如果想要在后台查看，可以登陆188后台选择纽币/人民币含税价和不含税价查看。"
          ]
        },
        {
          question: "我有实体店从平台进货在自己店里卖可以吗？",
          answer: [
            "这个行为不可以。平台所有产品都是直邮方式来到中国的，目前遵循的是行邮法，而不是通过一般贸易进口，产品在国内是没有交税的，国内相关不允许实体销售，因此线下销售这种行为是违法的。",
            "您备些样品举办一些让客户体验，试用之类的活动，这个不属于销售，无需担心。",
            "因此，我们推荐的形式为，您在实体店摆设样品，让客人现场体验，然后介绍客人通过平台下单，并将客人作为最终收件人，整个流程都通过网站平台完成，让销售行为合理合规。",
            "需要注意的是：国内每个人每年只有不超过2万元人民币的直邮收货量，超过容易被海关记录抽查，会影响其他正常贸易产品的通关和您的个人信誉，因此如果客人需要购买奶粉等刚需产品量又比较大的话可以建议客人使用家人的信息进行购买。"
          ]
        },
        {
          question: "平台如何确保真品？",
          answer: [
            "①我们有全球唯一溯源到包裹的CCIC小包裹认证，能让客人全程溯源包裹情况。",
            "②海外直邮，保证产品直接从仓库到达用户手中。",
            "③海外仓实时监控，让用户的包裹从没有出库就开始全程直播。",
            "④生产厂家直接出具的授权书，证明我们的产品来源。",
            "⑤奶粉遵循严格的RMP制度，直接从有RMP权限的物流仓库发货，保证产品品质。"
          ]
        },
        {
          question: "海淘代购不是跨境电商的原因？",
          answer: [
            "“海淘”是近年来兴起的网购消费潮流，指消费者不依赖代购商家，直接去国(境)外网购淘货，“海淘”的主体是个人，跨境电商的主体是资质企业，从法律效力上来讲企业比个人更安全靠谱。跨境电商企业通过集中海外采购，统一由海外发至国内。因为跨境电商一般都是海外集中采购，或者是国外品牌的销售商，所以价格上有很大优势，因此从以上两方面来讲跨境电商比海淘都有很大优势。跨境电商与海淘完全是两码事，抓住上面的核心点，基本上就能把两者区分开来。"
          ]
        },
        {
          question: "海外仓必须在原产地，为什么？",
          answer: [
            "海外仓能确定保证货品100%来自于海外，从根本上避免假货的出现。魔法灯是100%海外直采自营，原产地集货直邮的跨境电商模式，目前魔法灯已开设新西兰奥克兰海外仓、澳大利亚悉尼海外仓和德国杜塞尔多夫海外仓 ，随着公司市场的扩大，更多海外仓我们正在筹建中，敬请期待。"
          ]
        },
        {
          question: "何为出口、跨境电商？",
          answer: [
            "跨境电商是指分属不同关境的交易主体，通过电子商务平台达成交易、进行支付结算，并通过跨境物流送达商品、完成交易的一种国际商业活动。"
          ]
        },
        {
          question: "类似的代购平台很多，我们的平台优势有哪些？",
          answer: [
            "大部分的电商你都只能采购，也就是说以顾客的身份出现，买货-对方代发/囤货-卖出，这个过程随着时间推移，你会发现越做越辛苦，客人问题多到想哭，一天工作8小时，你的客人如果一个人和你询价问产品半个小时，你一天才能回答16个客人，而且还未必是成功的订单和销售。"
          ]
        },
        {
          question: "我们的优势：",
          answer: [
            "在时间空间人员不变的情况下，通过我们3.0销售系统帮你无限放大固定的时间，通过188后台分销分享，如果你坚持不懈，同一时间段达到千万人分销都不是不可能。假想一下，加入我们三个月后的早晨，一睁开眼，拿起手机点开188.nz的后台，眼前进入电子钱包进账的场景，哇塞，那心情，别说多美好了～"
          ]
        },
        {
          question: "强大的后台功能：",
          answer: [
            "Ø网站编辑",
            "Ø编辑网站信息，上传LOGO，联系方式和二维码",
            "Ø钱包管理",
            "Ø多币种利润管理，出入帐明细查询",
            "Ø分销管理",
            "Ø管理自己的分销网络，打造自己的销售团队",
            "Ø商品管理",
            "Ø清晰的看到每一样产品的价格，重量和库存",
            "Ø订单管理",
            "Ø轻松查询每一个订单的状态，物流，利润",
            "Ø客户管理",
            "Ø给客户分级，告别繁琐的报价，轻松应对大量客户"
          ]
        }
      ],
      school_2: [
        {
          question: "运费重量如何计算？",
          answer: [
            "根据发货仓库信息，",
            " · 新西兰仓库产品：单仓一公斤整单包邮普通线路。",
            " · 如果正品本身满一公斤，赠品包邮。",
            " · 如果正品没有满一公斤，赠品不凑重量。",
            " · 如果购买的产品没有满一公斤，就按照差额补交。",
            " · 例如购买产品A和B，重量分别为A300克，B400克，那就按照（1-（A+B）） 重量也就是1-（0.3+0.4）=0.3（千克）重量计算运费，如果客人订单不包含b其他产品，他的最终运费为0.3*运费。"
          ]
        },
        {
          question: "售后问题和谁联系？",
          answer: [
            "你可以直接联系我们的在线客服",
            " · 工作时间为：",
            " · 北京时间工作日 冬时令：早5点到晚22点（夏时令：4点到21点）",
            " · 双休日8点到17点，如遇节假日，根据节假另行调整，后台会另行通知。",
            // " · 联系方式：cs@miepay.com"
          ]
        },
        {
          question:
            "胶囊类，软糖类保健品以及口红，到货后可能会有粘连，软化或化解的情况，怎么处理？",
          answer: [
            "因为中国和新西兰到季节不同，由于天气原因，产品融化，这种情况属于不可控因素，冰箱保存一下，仔细剥离是不影响使用的；保健品液体类最好都放冰箱冷藏。"
          ]
        },
        {
          question: "到货后发现破损怎么处理？",
          answer: [
            "直邮产品因为长途运输气压变动和温度的急速变化以及国内物流的暴力现象等多方面原因。",
            "可能会出现破损现象，请尽量跟快递当面查验后，留下快递书面说明。",
            "如无法提供说明，请拍清楚破损产品的图片、包装、包装箱、快递单等，尽快联系客服。",
            "（详情见赔付政策）。"
          ]
        },
        {
          question: "清关时效是多久？",
          answer: [
            "清关时效是指在清关开始起到海关放行之间的时间，具体时效需要看海关工作人员的工作效率，没有办法给一个具体的时间保证，不同产品的清关时效会有差异。",
            "大致情况下，保健品类产品清关时效大概是2-4周。",
            "奶粉因为是粉末状的产品，清关时效会稍微久一点，大概需要4-8周",
            "如果遇到查验，可能会更久一点。"
          ]
        },
        {
          question: "包邮产品可以和其他产品一起购买么，是不是其他产品也包邮？",
          answer: [
            "包邮产品可以和其他产品一起下单~。",
            "包邮产品本身是包邮的.",
            "但是其他一起下单的产品需要单独根据当前运费政策计算的"
          ]
        },
        {
          question: "为什么新西兰的奶粉到货周期特别长？",
          answer: [
            "海关清关原因",
            "奶粉属于粉末状产品，会比一般保健品清关再慢一些。",
            "新西兰独有的RMP制度流程多、严谨一些。",
            "根据新西兰的法律（动物产品案法，1999年）只有注册的出口商才有资格出口乳制品，新西兰农林局严查乳制品运营商相关资质。根据新西兰农林局的要求，乳制品从奶源到出厂运输的所有过程，包括运输使用的车辆、仓库在内都必须符合RMP规范，接受农林部的监管。如果乳制品脱离了这个安全链的任何一个环节，将被视为不符合RMP规范，该产品将不能出口"
          ]
        },
        {
          question: "海关查验（二次清关）是什么意思？大概多久？",
          answer: [
            "查验是指海关在接受报关单位的申报并已经审核的申报单位为依据，通过对出口货物进行实际的核查，以确定其报关单证申报的内容是否与实际进出口的货物相符的一种监管方式。简单的说，查验相当于重新进行一次清关。",
            "查验会使包裹的清关时间略有延长，时间为从开始查验一个月左右。"
          ]
        },
        {
          question: "奶粉和保健品类的可以一起下单吗？",
          answer: [
            "奶粉和保健品、食品类产品是可以一起下单的。",
            "但是婴儿奶粉有运送限制只能单独运输",
            "如果购买成人奶粉可能会和保健品分在一起发出。"
          ]
        },
        {
          question: "我的身份证为什么上传不成功，怎么办？",
          answer: [
            "上传身份证失败，根据仓位不同，解决方案也不同.",
            "新西兰仓库普通产品目前对接的物流为新顺丰物流，如果身份证上传失败，物流会按照以下流程办理：由于有的客户写错姓名、没有及时上传身份证、有效期低于三个月、照片不清晰，上传身份证质量不过关，所以物流可能会用自己员工的姓名帮助清关（修改了收件人的姓名）但是收件电话和地址，还有包裹内产品是正确的，也是为了让包裹能尽早清关，请客户签收，不要拒收。即包裹会被发走，但是可能修改了姓名，一般电话和地址都是不会修改的。需要打开查看产品是否对应，如果不对，保留面单和产品照片，及时联系客服，办理赔付手续。",
            "新西兰仓奶粉类产品会发送随机物流，具体身份证上传情况如果存在问题，需联系客服询问。",
            "身份证号码，务必保证不超过2万人民币的进口商品购买额度。如有超过，客服会联系顾客，提供其他人的真实有效身份证号码，否则可能会导致无法通关。"
          ]
        },
        {
          question: "新西兰直邮产品需要上传身份证吗？",
          answer: [
            "是需要的。新西兰发货默认新顺丰国际物流，下单后，请到新顺丰国际物流官网www.nsf.co.nz或添加微信公共账号nsf_ex进行上传，请保证上传的证件姓名与收件人姓名一致（物流只默认中国大陆身份证，如果是外国人或者香港居民，还请更改收件人姓名后上传身份证信息）。如第一次填写错误，第二次需联系客服提供身份证照片+号码。身份证号码，务必保证不超过2万人民币的进口商品购买额度。如有超过，客服会联系顾客，提供其他人的真实有效身份证号码，否则可能会导致无法通关。"
          ]
        }
      ],
      school_3: [
        {
          question: "赔偿范畴：",
          answer: [
            "1. 关于奶粉类的赔偿：",
            "凡在运输过程中造成的奶粉类出现的爆罐即不能食用给予全额赔偿；由于长途跋涉，对于瘪罐现象很难控制，因此不在赔偿范畴之内。",
            "2. 蜂蜜类产品的赔偿：",
            "如果瓶盖破损，不影响食用，根据实际具体情况给予最低赔付标准（20%）赔偿。",
            "如果出现侧漏或破损，根据实际具体情况给予按照货物撒漏比例的赔偿。如果全部破损，即不能食用给予全额赔偿。",
            "3. 液体类产品的赔偿：",
            "如果出现破损， 即不能食用给予全额赔偿，但由于液体溢漏导致其他产品被污染的不予赔偿；如果出现测漏或不严重的破损，根据实际具体情况给予按照货物撒漏比例的赔偿。",
            "4.其他类产品如果完全破损导致无法食用，照价赔偿；如果瓶盖破损，不影响食用，根据实际具体情况给予最低赔付标准（20%）赔偿。",
            "5. 因为天气原因，温差等不可抗力的影响造成质量变化的保健品、化妆品请联系客服酌情赔付。",
            "6. 一部分外包装特殊的食品,例如薯片,盐,意大利面,奶片,饼干,巧克力此类的食品,由于产品的外包装较为特殊,容易破损,所以不在赔偿的范围之内。",
            "7. 由于收件人填写不清楚，电话错误，地址错误或者客户无故拒收导致无法及时送货, 二次派送后若还无法送达到客户手上的不在赔偿范畴之内（产生的二次派送费由收件人自行支付）。",
            "8. 赔付时效：为了提高我们赔付的效率，请发现问题后及时联系我们, 并提供快递单号及破损包裹相关照片做凭证用。",
            "9. 赔付金额的限定：针对任何丢件，少件将给予货价加运费的全额赔偿。 如邮寄单个包裹价值高于$250 纽币，则最高赔付金额为$250.",
            "10. 针对所有赔偿申请，寄件人必须提供赔偿物品的破损图片，物流包装箱图片，快递单图片。如不能提供全面，将不予赔付。"
          ]
        },
        {
          question: "赔付流程：",
          answer: [
            "1. 务必本人当场验货签收，不要拒收包裹，不能让门卫，保安或朋友代收，如果当场验货发现赔付范畴内的破损（参见赔付范畴），需当面和快递员核实，并且让快递员在底单上写明情况。收件人务必保留底单，在收货后 2 个工作日内拍照，并及时联系客服，超出时效或不能全面提供破损图片，将不予赔付。",
            "内容：破损产品名称，数量，包裹带快递单图片，破损产品清晰的图片（如多个破损产品，务必单个拍照破损，然后一起拍照）。",
            "2.如果送货快递员拒绝验货，请先签收。 签收后，如发现赔付范畴内的产品赔偿问题（参见赔偿范畴），务必在收货 2 个工作日内按照破损赔偿的格式及时联系客服。",
            "3. 针对所有赔付收件人需在签收后 2 个工作日内按照规定格式及时联系客服申请理赔，逾期不予赔偿.",
            "4.凡按照以上赔付流程操作，我们会尽快联系物流进行赔付，赔付后立即反馈，在双方协商确认后予以退款. 注： 物流中所发生的破损赔付，不接受任何以不能二次销售为由的赔偿（赔偿依据为是否影响使用或食用）。"
          ]
        }
      ],
      school_4: [
        {
          question: "如何获取自己的利润？",
          answer: [
            "订单的利润，在用户完成订单下单，产品实际出库后，后台会自动结算利润，并将相应金额自动转入电子钱包中。但电子钱包中的金额达到人民币250元或者纽币/澳币50元的时候，就可以进行提现操作，将利润提现到支付宝或者银行卡，就可以获取到自己的利润啦。"
          ]
        },
        {
          question: "订单的退款是退给谁？",
          answer: [
            "分两种情况：",
            "一、北京时间2019年4月17日11:30开始，人民币付款订单退款可以原路退回了",
            "关于原路退回说明：",
            "1.订单必须是未出库的人民币付款订单（只针对网站人民币下单选择微信支付或者支付宝支付，小程序订单支付）",
            "2.其他情况付款的订单（网站银行转账支付，网站polipay支付）和已经出库的订单退款仍会将钱退到后台的电子钱包",
            "3.北京时间2019年4月16日11:30分之前付款的所有订单，仍会将钱退到后台的电子钱包",
            "二、如订单已成功发货后产生退款，退款将退至下单网站的188电子钱包。"
          ]
        },
        {
          question: "终端客户如何付款？",
          answer: [
            "目前平台支持最主流的支付宝或者微信支付，如果需要银行卡支付，可以将银行卡绑定在支付宝上进行支付"
          ]
        },
        {
          question: "收的产品包装和之前不一样，是什么原因？",
          answer: [
            "由于海外厂家包装更新频繁，且产品部产品周期运转较快，偶尔会发生仓库多批次产品新旧包装混发的情况，但是都能保证真品，正品的，客人无需担心品质的呢。"
          ]
        }
      ]
    };
  },

  // 跨境商学院导航 school_subbar
  school_subbar() {
    return {
      active: 0,
      data: [
        // {
        //   url: "/school",
        //   name: "跨境商学院"
        // },
        {
          url: "/school_1",
          name: "行业知识"
        },
        {
          url: "/school_2",
          name: "仓储物流"
        },
        {
          url: "/school_3",
          name: "赔付标准"
        },
        {
          url: "/school_4",
          name: "售后服务"
        }
      ],
      setup(key) {
        this.active = key;
      }
    };
  },

  // about img_bg about_img_bg
  about_img_bg() {
    return {
      height: "566px",
      bg_img: "/img/bg_about.png",
      title: "关于MYPAY NZ",
      sub: "金融科技企业构建创新金融科技生态系统",
      desc: [
        "MYPAY NZ是新西兰一家技术驱动的支付公司，为零售商家和终端客户之间提供线上线下便利服务。",
        "我们的主营业务有聚合支付、本地商户线上线下销售与支付整体解决方案和跨境Kimi Mall商城。"
      ]
    };
  },

  // about tips about_tips
  about_tips() {
    return {
      item_style: "box-shadow:0px 1px 15px 0px rgba(207,218,228,0.4);",
      list: [
        {
          ico: "/img/about/icon_new_1.png",
          size: "160px",
          title: "我们的使命",
          sub: "让人们都能拥有自己的商业"
        },
        {
          ico: "/img/about/icon_new_2.png",
          size: "160px",
          title: "我们的任务",
          sub: "提供本地和跨境支付服务和跨境电商 解决方案"
        },
        {
          ico: "/img/about/icon_new_3.png",
          size: "160px",
          title: "关键优势",
          sub:
            "汇集本地上千个商户和品牌的产品优势，核心运营和开发团队提供聚合支付和跨境电商解决方案"
        }
      ]
    };
  },

  // about step about_step
  about_step() {
    return {
      title: "企业发展历程",
      steps: [
        {
          done: true,
          date: "2020年5月18日",
          title: "上市",
          desc: "MIEPAY 在澳大利亚国家证券交易所（NSX）成功上市，交易代码（MIE)"
        },
        {
          done: true,
          date: "2019年7月4日",
          title: "成为 UnionPay 合作伙伴",
          desc: "MyPay 新西兰公司成为银联合作伙伴"
        },
        {
          done: true,
          date: "2018年12月19日",
          title: "剥离",
          desc:
            "MIE Pay 新西兰有限公司在新西兰成立，作为公司的全资子公司，作为持有 MyPay 新西兰有限公司的附属实体，作为 MyPay 新西兰公司从 IEFS 剥离至 MIE 新西兰公司的一部分"
        },
        {
          done: true,
          date: "2018年12月",
          title: "ieShop上线",
          desc: "MyPay NZ 推出 ieShop 电子商务云平台"
        },
        {
          done: true,
          date: "2018年12月",
          title: "Green Cross Health",
          desc: "新西兰最大的医药和美妆集团绿十字成为 MyPay 商户"
        },
        {
          done: true,
          date: "2018年11月1日",
          title: "MIE PAY NZ 成立",
          desc:
            "本公司于2018年11月1日在新南威尔士州成立，是 MIE Pay 新西兰有限公司(MIE PAY NZ)的控股公司，MIE Pay 新西兰公司又持有 MyPay 新西兰有限公司(MyPay NZ)"
        },
        {
          done: false,
          date: "2017年10月26日",
          title: "成为 WeChat Pay 合作伙伴",
          desc: "MyPay 新西兰公司成为 WeChat Pay 合作伙伴"
        },
        {
          done: false,
          date: "2016年9月",
          title: "成为 Alipay 合作伙伴",
          desc: "MyPay 新西兰公司成为支付宝的第一位新西兰合作伙伴"
        },
        {
          done: false,
          date: "2016年5月9日",
          title: "成立",
          desc:
            "MyPay 新西兰于2016年5月9日在新西兰注册成立，是 IE 金融服务集团的一部分，以利用全球电子商务的增长以及新西兰和澳大利亚市场对综合支付平台的需求。其最终控股公司是IE金融服务有限公司(IEFS)"
        }
      ],
      stepFn() {
        var self = this;
        var el = document.getElementById("step");
        var span = screen.height / 2 + 300;
        var items =  el.getElementsByClassName("step-box");

        window.addEventListener("scroll", function() {
          var sY = window.scrollY || document.body.scrollTop;

          for(var i = 0; i < items.length; i++) {
            var offsetT = items[i].offsetTop - span;
            if(sY >= offsetT) {
              self.steps[i].done = true;
            } else {
              self.steps[i].done = false;
            }
          }
        });
      }
    };
  },

  // register grogress register_progress
  register_progress() {
    return {
      todo: 1,
      data: [
        {
          type: "text",
          key: 1,
          name: "基本信息"
        },
        {
          type: "line"
        },
        {
          type: "text",
          key: 2,
          name: "结算信息"
        },
        {
          type: "line"
        },
        {
          type: "text",
          key: 3,
          name: "完成提交"
        }
      ],
      setup(todo) {
        this.todo = todo;
      },
      isLine(k) {
        return this.data[k].type == "line";
      },
      isDone(key) {
        return this.todo > key;
      }
    };
  },

  // register data register_data
  register_data() {
    return {
      active: 1,
      form_item_width: "450px",
      progress: [
        {
          type: "text",
          key: 1,
          name: "基本信息"
        },
        {
          type: "text",
          key: 2,
          name: "结算信息"
        },
        {
          type: "text",
          key: 3,
          name: "完成提交"
        }
      ],
      form_f: [
        {
          type: "type_change",
          value: 0,
          data: ["Personal", "Business"]
        },
        {
          type: "text",
          label: "国家",
          value: "中国",
          placeholder: "请输入国家"
        }
        // {
        //   type: 'mobile',
        //   label: '电话',
        //   value: '',
        //   extr: {
        //     value: 1,
        //     data: [
        //       {label: '+86', value: 1}
        //     ]
        //   },
        //   placeholder: '电话号码'
        // },
        // {
        //   type: 'code',
        //   label: '验证码',
        //   value: '',
        //   placeholder: '请输入验证码',
        //   btn: {
        //     txt: '获取验证码'
        //   }
        // },
        // {
        //   type: 'password',
        //   label: '密码',
        //   value: '',
        //   placeholder: '请输入密码',
        // },
        // {
        //   type: 'password',
        //   origin: 'password',
        //   label: '确认密码',
        //   value: '',
        //   palceholder: '再次输入密码'
        // },
        // {
        //   type: 'text',
        //   label: '姓名',
        //   value: '',
        //   placeholder: '请填写真实姓名'
        // },
        // {
        //   type: 'text',
        //   label: '省份',
        //   value: '',
        //   placeholder: '请输入省份'
        // },
        // {
        //   type: 'text',
        //   label: '行业',
        //   value: '',
        //   placeholder: '请输入行业'
        // },
        // {
        //   type: 'text',
        //   label: '电子邮箱',
        //   value: '中国',
        //   placeholder: '请输入电子邮箱',
        //   sub: '注册后你可以使用电子邮箱或手机号码登录'
        // },
        // {
        //   type: 'pin',
        //   label: 'PIN code',
        //   sub: '设置PIN码',
        //   value: '',
        //   value_two: '',
        //   placeholder: ['请输入Pin码', '再次输入Pin码']
        // },
        // {
        //   type: 'question',
        //   label: '安全问题',
        //   question: '',
        //   value: '',
        //   placeholder: ['请输入问题', '请输入答案']
        // },
        // {
        //   type: 'checkbox',
        //   label: '加盟类型',
        //   value: '',
        //   data: [
        //     {label: '线上分销', value: 1},
        //     {label: '线下实体店加盟', value: 2},
        //   ]
        // },
        // {
        //   type: 'textarea',
        //   label: '其他说明',
        //   value: '',
        //   placeholder: '请输入其他说明'
        // },
      ],
      form_f_submit_txt: "下一步",
      form_s: [
        {
          type: "text",
          label: "身份证正面",
          name: "id_card_img"
        },
        {
          type: "text",
          label: "身份证反面",
          name: "id_card_img_o"
        },
        {
          type: "text",
          label: "结算银行",
          value: "",
          name: "people_name",
          placeholder: "姓名"
        },
        {
          type: "text",
          value: "",
          name: "people_bank",
          placeholder: "银行账号"
        }
      ],
      form_s_submit_txt: "提交",
      success: {
        icon: "/img/icon_success.png",
        title: "您的渠道加盟申请已提交",
        sub: "我们将于三个工作日内对您的材料进行审核并反馈申请结果。",
        email: "ieFranchisee@miepay.com",
        qrcode: ""
      },
      getProgressData() {
        let arr = [];
        for (let i = 0; i < this.progress.length; i++) {
          arr.push(this.progress[i]);
          if (i != this.progress.length - 1) {
            arr.push({
              type: "divide"
            });
          }
        }
        return arr;
      },
      isProgressDone(key) {
        return this.active > key;
      },
      isSpecial(key) {
        return ["type_change"].indexOf(key) != -1;
      },
      next() {
        console.log("next");
        this.active = 2;
      },
      submit() {
        console.log(this.form_s);
        console.log("submit");
        // this.active = 3;
      }
    };
  }
};
